var componentsList = (function () {
    const init = function () {
      $('#add-iq-input').on('keyup', function() {
        if ($('#add-iq-input').val().length == 0)
          $('#add-iq-button').attr('disabled', 'disabled');
        else
          $('#add-iq-button').attr('disabled', false);
      });
      $("#add-iq-open-modal").on("click", function () {
        $("#add-iq-input").val("");
        $('#add-iq-button').attr('disabled', 'disabled');
      });
      $("#add-iq-button").on("click", function () {
        sendAddIqRequest($("#add-iq-input").val());
      });
      $('#edit-iq-input').on('keyup', function() {
        if ($('#edit-iq-input').val().length == 0)
          $('#edit-iq-button').attr('disabled', 'disabled');
        else
          $('#edit-iq-button').attr('disabled', false);
      });
      $(".iq-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-iq-input").val(name);
        $("#edit-iq-button").attr("data-component-id", id);
      });
      $("#edit-iq-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditIqRequest(id, $("#edit-iq-input").val());
      });
      $(".iq-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#iq-name-to-delete").text(name);
        $("#delete-iq-button").attr("data-component-id", id);
      });
      $("#delete-iq-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeleteIqRequest(id);
      });
      
      $('#add-pump-input').on('keyup', function() {
        if ($('#add-pump-input').val().length == 0)
          $('#add-pump-button').attr('disabled', 'disabled');
        else
          $('#add-pump-button').attr('disabled', false);
      });
      $("#add-pump-open-modal").on("click", function () {
        $("#add-pump-input").val("");
        $('#add-pump-button').attr('disabled', 'disabled');
      });
      $("#add-pump-button").on("click", function () {
        sendAddPumpRequest($("#add-pump-input").val());
      });
      $('#edit-pump-input').on('keyup', function() {
        if ($('#edit-pump-input').val().length == 0)
          $('#edit-pump-button').attr('disabled', 'disabled');
        else
          $('#edit-pump-button').attr('disabled', false);
      });
      $(".pump-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-pump-input").val(name);
        $("#edit-pump-button").attr("data-component-id", id);
      });
      $("#edit-pump-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditPumpRequest(id, $("#edit-pump-input").val());
      });
      $(".pump-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#pump-name-to-delete").text(name);
        $("#delete-pump-button").attr("data-component-id", id);
      });
      $("#delete-pump-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeletePumpRequest(id);
      });
      
      $('#add-meter-input').on('keyup', function() {
        if ($('#add-meter-input').val().length == 0)
          $('#add-meter-button').attr('disabled', 'disabled');
        else
          $('#add-meter-button').attr('disabled', false);
      });
      $("#add-meter-open-modal").on("click", function () {
        $("#add-meter-input").val("");
        $('#add-meter-button').attr('disabled', 'disabled');
      });
      $("#add-meter-button").on("click", function () {
        sendAddMeterRequest($("#add-meter-input").val());
      });
      $('#edit-meter-input').on('keyup', function() {
        if ($('#edit-meter-input').val().length == 0)
          $('#edit-meter-button').attr('disabled', 'disabled');
        else
          $('#edit-meter-button').attr('disabled', false);
      });
      $(".meter-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-meter-input").val(name);
        $("#edit-meter-button").attr("data-component-id", id);
      });
      $("#edit-meter-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditMeterRequest(id, $("#edit-meter-input").val());
      });
      $(".meter-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#meter-name-to-delete").text(name);
        $("#delete-meter-button").attr("data-component-id", id);
      });
      $("#delete-meter-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeleteMeterRequest(id);
      });
      
      $('#add-filter-input').on('keyup', function() {
        if ($('#add-filter-input').val().length == 0)
          $('#add-filter-button').attr('disabled', 'disabled');
        else
          $('#add-filter-button').attr('disabled', false);
      });
      $("#add-filter-open-modal").on("click", function () {
        $("#add-filter-input").val("");
        $('#add-filter-button').attr('disabled', 'disabled');
      });
      $("#add-filter-button").on("click", function () {
        sendAddFilterRequest($("#add-filter-input").val());
      });
      $('#edit-filter-input').on('keyup', function() {
        if ($('#edit-filter-input').val().length == 0)
          $('#edit-filter-button').attr('disabled', 'disabled');
        else
          $('#edit-filter-button').attr('disabled', false);
      });
      $(".filter-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-filter-input").val(name);
        $("#edit-filter-button").attr("data-component-id", id);
      });
      $("#edit-filter-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditFilterRequest(id, $("#edit-filter-input").val());
      });
      $(".filter-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#filter-name-to-delete").text(name);
        $("#delete-filter-button").attr("data-component-id", id);
      });
      $("#delete-filter-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeleteFilterRequest(id);
      });
      
      $('#add-nozzle-input').on('keyup', function() {
        if ($('#add-nozzle-input').val().length == 0)
          $('#add-nozzle-button').attr('disabled', 'disabled');
        else
          $('#add-nozzle-button').attr('disabled', false);
      });
      $("#add-nozzle-open-modal").on("click", function () {
        $("#add-nozzle-input").val("");
        $('#add-nozzle-button').attr('disabled', 'disabled');
      });
      $("#add-nozzle-button").on("click", function () {
        sendAddNozzleRequest($("#add-nozzle-input").val());
      });
      $('#edit-nozzle-input').on('keyup', function() {
        if ($('#edit-nozzle-input').val().length == 0)
          $('#edit-nozzle-button').attr('disabled', 'disabled');
        else
          $('#edit-nozzle-button').attr('disabled', false);
      });
      $(".nozzle-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-nozzle-input").val(name);
        $("#edit-nozzle-button").attr("data-component-id", id);
      });
      $("#edit-nozzle-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditNozzleRequest(id, $("#edit-nozzle-input").val());
      });
      $(".nozzle-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#nozzle-name-to-delete").text(name);
        $("#delete-nozzle-button").attr("data-component-id", id);
      });
      $("#delete-nozzle-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeleteNozzleRequest(id);
      });
      
      $('#add-discharge-input').on('keyup', function() {
        if ($('#add-discharge-input').val().length == 0)
          $('#add-discharge-button').attr('disabled', 'disabled');
        else
          $('#add-discharge-button').attr('disabled', false);
      });
      $("#add-discharge-open-modal").on("click", function () {
        $("#add-discharge-input").val("");
        $('#add-discharge-button').attr('disabled', 'disabled');
      });
      $("#add-discharge-button").on("click", function () {
        sendAddDischargeKitRequest($("#add-discharge-input").val());
      });
      $('#edit-discharge-input').on('keyup', function() {
        if ($('#edit-discharge-input').val().length == 0)
          $('#edit-discharge-button').attr('disabled', 'disabled');
        else
          $('#edit-discharge-button').attr('disabled', false);
      });
      $(".discharge-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-discharge-input").val(name);
        $("#edit-discharge-button").attr("data-component-id", id);
      });
      $("#edit-discharge-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditDischargeKitRequest(id, $("#edit-discharge-input").val());
      });
      $(".discharge-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#discharge-name-to-delete").text(name);
        $("#delete-discharge-button").attr("data-component-id", id);
      });
      $("#delete-discharge-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeleteDischargeKitRequest(id);
      });
      
      $('#add-suction-input').on('keyup', function() {
        if ($('#add-suction-input').val().length == 0)
          $('#add-suction-button').attr('disabled', 'disabled');
        else
          $('#add-suction-button').attr('disabled', false);
      });
      $("#add-suction-open-modal").on("click", function () {
        $("#add-suction-input").val("");
        $('#add-suction-button').attr('disabled', 'disabled');
      });
      $("#add-suction-button").on("click", function () {
        sendAddSuctionKitRequest($("#add-suction-input").val());
      });
      $('#edit-suction-input').on('keyup', function() {
        if ($('#edit-suction-input').val().length == 0)
          $('#edit-suction-button').attr('disabled', 'disabled');
        else
          $('#edit-suction-button').attr('disabled', false);
      });
      $(".suction-list").on("click", ".mdi-lead-pencil", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#edit-suction-input").val(name);
        $("#edit-suction-button").attr("data-component-id", id);
      });
      $("#edit-suction-button").on("click", function () {
        const id = $(this).data("component-id");
        sendEditSuctionKitRequest(id, $("#edit-suction-input").val());
      });
      $(".suction-list").on("click", ".mdi-delete", function () {
        const id = $(this).data("component-id");
        const name = $(this).data("component-name");
        $("#suction-name-to-delete").text(name);
        $("#delete-suction-button").attr("data-component-id", id);
      });
      $("#delete-suction-button").on("click", function () {
        const id = $(this).data("component-id");
        sendDeleteSuctionKitRequest(id);
      });

      function sendAddIqRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddIqModel`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-iq-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditIqRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditIqModel`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-iq-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeleteIqRequest(id) {
        $.ajax({
          url: `/Components/DeleteIqModel/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-iq-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }



      function sendAddPumpRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddPump`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-pump-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditPumpRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditPump`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-pump-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeletePumpRequest(id) {
        $.ajax({
          url: `/Components/DeletePump/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-pump-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }

      function sendAddMeterRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddMeter`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-meter-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditMeterRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditMeter`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-meter-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeleteMeterRequest(id) {
        $.ajax({
          url: `/Components/DeleteMeter/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-meter-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }

      function sendAddFilterRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddFilter`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-filter-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditFilterRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditFilter`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-filter-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeleteFilterRequest(id) {
        $.ajax({
          url: `/Components/DeleteFilter/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-filter-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }

      function sendAddNozzleRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddNozzle`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-nozzle-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditNozzleRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditNozzle`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-nozzle-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeleteNozzleRequest(id) {
        $.ajax({
          url: `/Components/DeleteNozzle/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-nozzle-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }

      function sendAddDischargeKitRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddDischargeKit`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-discharge-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditDischargeKitRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditDischargeKit`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-discharge-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeleteDischargeKitRequest(id) {
        $.ajax({
          url: `/Components/DeleteDischargeKit/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-discharge-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }

      function sendAddSuctionKitRequest(name) {
        const viewModel = {
          Name: name,
        };
        $.ajax({
          url: `/Components/AddSuctionKit`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#add-suction-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendEditSuctionKitRequest(id, name) {
        const viewModel = {
          Id: id,
          Name: name,
        };
        $.ajax({
          url: `/Components/EditSuctionKit`,
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          $("#edit-suction-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
      function sendDeleteSuctionKitRequest(id) {
        $.ajax({
          url: `/Components/DeleteSuctionKit/${id}`,
          method: "DELETE",
          contentType: "application/json",
        }).done(function (data) {
          $("#delete-suction-modal").modal("hide");
          $.showNotification(data.header, data.message, data.success);
        });
      }
    };
  
    return {
      init: init,
    };
  })();
  